var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    x: 0,
    y: 0,
    enableBackground: "new 0 0 56 56",
    viewBox: "0 0 505.859 505.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ecca34",
    d: "M252.93 30.932L49.136 146.435a236.667 236.667 0 00-15.039 29.598c-11.998 28.391-18.632 59.602-18.632 92.363 0 66.242 27.123 126.149 70.87 169.221l333.879-.684c43.341-43.021 70.178-102.645 70.178-168.537.001-131.148-106.315-237.464-237.462-237.464z",
    "data-original": "#ecca34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc6920",
    d: "M49.143 146.439v120.73l106.538-95.25h2.823v260.392h105.128V41.39h-80.594C126.51 58.774 78.979 96.691 49.143 146.439z",
    "data-original": "#dc6920"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5339d3",
    d: "M193.748 394.031H86.347v43.575a238.755 238.755 0 0013.562 12.347h306.046a238.787 238.787 0 0014.254-13.027v-42.895h-95.543V18.822C324.665 8.427 316.238 0 305.843 0h-99.352a18.821 18.821 0 00-12.545 4.79L85.65 101.612v165.244l108.097-96.645v223.82z",
    "data-original": "#5339d3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b3896",
    d: "M311.163 407.534L298.701 27.276 204.46 13.503 99.153 107.652v129.019l72.608-80.409 32.698-13.74h2.791v265.012H99.85l31.132 64.641h243.852a238.18 238.18 0 0031.872-22.847v-41.794z",
    "data-original": "#3b3896"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b66fa",
    d: "M216.295 44.499h63.872V438.53l30.996-30.996V13.503H204.46z",
    "data-original": "#6b66fa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b66fa",
    d: "M235.146 111.526h-42.522l-8.823 7.889-53.652 47.967-30.996 69.289 105.307-94.149zM99.85 407.534v42.382c41.338 34.896 94.747 55.943 153.08 55.943 32.571 0 63.608-6.563 91.867-18.431l1.194-.506a236.697 236.697 0 0031.343-16.235H130.845V438.53z",
    "data-original": "#6b66fa"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b66fa",
    d: "M253.759 452.802h-8.642V82.211h-37.382l-77.73 68.842-5.73-6.469 80.183-71.015h49.301z",
    "data-original": "#6b66fa"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6b66fa",
    d: "M128.961 448.481h239.423v8.642H128.961z",
    "data-original": "#6b66fa"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.65 300.068l3.611 9.465a17.816 17.816 0 0010.296 10.296l9.465 3.611-9.465 3.611a17.816 17.816 0 00-10.296 10.296l-3.611 9.465-3.611-9.465a17.816 17.816 0 00-10.296-10.296l-9.465-3.611 9.465-3.611a17.816 17.816 0 0010.296-10.296zM373.878 111.799l4.885 12.806a24.102 24.102 0 0013.93 13.93l12.806 4.885-12.806 4.885a24.102 24.102 0 00-13.93 13.93l-4.885 12.806-4.885-12.806a24.102 24.102 0 00-13.93-13.93l-12.806-4.885 12.806-4.885a24.102 24.102 0 0013.93-13.93zM413.937 260.009l5.521 14.473a27.242 27.242 0 0015.743 15.743l14.473 5.521-14.473 5.521a27.242 27.242 0 00-15.743 15.743l-5.521 14.473-5.521-14.473a27.242 27.242 0 00-15.743-15.743l-14.473-5.521 14.473-5.521a27.242 27.242 0 0015.743-15.743z",
    "data-original": "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.63c2549567d286bff7def2b71b39b338.svg";
export { ForwardRef as ReactComponent };